import Vue from 'vue'
import CustomTable from '@/components/custom/table/Component.vue'

import WVInput from '@/components/WVInput.vue'
import WVTextarea from '@/components/WVTextarea.vue'
import WVSelect from '@/components/WVSelect.vue'
import WVVSelect from '@/components/WVVSelect.vue'

Vue.component('CustomTable', CustomTable)

Vue.component('WVInput', WVInput)
Vue.component('WVTextarea', WVTextarea)
Vue.component('WVSelect', WVSelect)
Vue.component('WVVSelect', WVVSelect)
